module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/toc01#chap_06",
      "id": "chap06"
    }
  }, [_vm._v("WHY ARE THE GROWN-UPS IN CHARGE?")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterAuthor"
  }, [_vm._v("Miranda Hart")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("comedian, writer and actress")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I have to say, I do sometimes wonder myself. Maybe you have asked this question because you have seen grown-ups doing things you don’t understand or telling you to do things that don’t seem right or fair. I’m sure you think you would be much happier if you didn’t have to do what they tell you. And sometimes, although I am supposedly one of the grown-ups, when someone older than me, or in a superior job to me, tells me what to do, I can get very angry and think they are wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But here is the thing. We have to trust that people older than us have so much experience and wisdom of life that they are making the right decisions, with our safety and interests at heart because they love us. It may not always feel that way at the time and sometimes grown-ups do get it wrong. If you strongly disagree then you must calmly tell them without getting cross and see what they say. But basically, as people get older, their life experiences mean they are cleverer and know best and that’s why they have to be in charge. One day when you are a grown-up you will realise exactly what I mean.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I do, however, want to share one little secret with you. I think adults can go wrong because they forget what it’s like to be a child. So you can remind the grown-ups of three key things:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Firstly, that it’s important to take time out to play with you. Because sometimes they can work too hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Secondly, remind them to stop worrying what others think of them, just be themselves and boldly claim what their dreams are. It’s very silly not to follow your dreams, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And lastly, you can teach them to take each day at a time, milk every last bit of fun from it, and not worry about tomorrow. Because grown-ups forget to be free and joyful in the moment and you are brilliant at that.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbe1bef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap06.vue
// module id = 87
// module chunks = 0